import { render, staticRenderFns } from "./horn.vue?vue&type=template&id=aa443532"
import script from "./horn.vue?vue&type=script&lang=js"
export * from "./horn.vue?vue&type=script&lang=js"
import style0 from "./horn.vue?vue&type=style&index=0&id=aa443532&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports